import { Injectable } from '@angular/core';
import {ToastController} from 'ionic-angular';
import { interval } from 'rxjs/observable/interval';

import { RcsConnectorOdooProvider } from '../rcs-connector-odoo/rcs-connector-odoo';
import { ReplacementPartsProvider } from '../replacement-parts/replacement-parts';
import { SyncProductsProvider } from '../rcs-sync-data-service/sync-products.service';
import { Observable } from 'rxjs';
import {RcsConnectorIndexDbProvider} from "../rcs-connector-index-db/rcs-connector-index-db";
import {StackService} from "../odoo/stack.service";
import { ENV } from '@app/env';

@Injectable()
export class RcsStartupServiceProvider {
  private check:any;

  constructor(
    private stack: StackService,
    private toast_controller: ToastController,
    private odoo_connector: RcsConnectorOdooProvider,
    private replacement_service: ReplacementPartsProvider,
    private sync_products_service: SyncProductsProvider,
    private db_service: RcsConnectorIndexDbProvider,
  ){
      if (localStorage.getItem("online_status") == undefined){
        localStorage.setItem("online_status", 'true');
      }

      //this.start_app_processes();
    }

  private create_toast(msg:string, duration:number):void{
    let toast = this.toast_controller.create({
      message: msg,
      duration: duration,
      position: 'top'
    });
    toast.present();
  }

  public start_app_processes(){
    this.odoo_connector.load_connection_data();
    this.start_auto_product_sync();
    //this.start_auto_job_sync();

    this.createOnline$().subscribe(online => {
      if (online){
        this.stack.setNetworkState(true);

        this.create_toast("Sie sind wieder Online!", 3000);
        setTimeout(() => {
          console.log(navigator.serviceWorker, "ABC");
          if (navigator.serviceWorker && ENV.production) {
            navigator.serviceWorker.ready.then((registration) => {
              console.log(registration);
              return registration.update();
            });
          }
        
          this.replacement_service.save_delieverable_item();
          this.stack.running();
        }, 5000);
      } else {
        this.stack.setNetworkState(false);
        this.create_toast("Sie sind jetzt Offline!", 3000);
      }
    })
  }

  private createOnline$() {
    return Observable.merge(
      Observable.fromEvent(window, 'offline').map(() => false),
      Observable.fromEvent(window, 'online').map(() => true),
      Observable.create(sub => {
        sub.next(navigator.onLine);
        //sub.complete(); //this one only emits once, so now we end it
      })
    );
  }

  private start_auto_product_sync(){
    interval(1800000).subscribe(
      time => {
        if (!localStorage.getItem('sync') && localStorage.getItem("online_status") == "true"){
          this.sync_products_service.sync_products(false);
        }
      }
    )
    setTimeout(() => {
      console.log("Start Products", this.sync_products_service);
      if (localStorage.getItem("online_status") == 'true'){
        this.sync_products_service.sync_products(false);
      }
    }, 5000);
  }
}



// WEBPACK FOOTER //
// ./src/providers/rcs-setup-service/rcs-startup-service.ts